class Usuario {
    constructor(id, ativo, email, nome,unidade,listaPerfil, username){
        this.id = id;
        this.ativo = ativo;
        this.email = email;
        this.nome = nome;
        this.unidade = unidade ; 
        this.listaPerfil = listaPerfil;
        this.username = username;   
    }
}

export default Usuario;
